export default __webpack_public_path__ + "static/media/movie-filter-gradient.a4478c52.svg";